import { BreakCategory } from '@sdk/settings/types';

import { useAutomatedBreaksSettings } from '@web/settings/components/schedule/Breaks/breaks.hooks';
import useIsAutomatedBreaksFeatureFlagEnabled from '@web/automatedBreaks/hooks/useIsAutomatedBreaksFeatureFlagEnabled';
import { useUserOrgSettings } from '@web/settings/UserOrgSettingsContext';

const useAutomatedBreaksEnabled = () => {
  const { automatedBreaks } = useAutomatedBreaksSettings();
  const featureFlagEnabled = useIsAutomatedBreaksFeatureFlagEnabled();
  const {
    userOrgSettings: { shiftBreakType },
  } = useUserOrgSettings();

  return featureFlagEnabled && automatedBreaks.isEnabled && shiftBreakType !== BreakCategory.off;
};

export default useAutomatedBreaksEnabled;
